import React from "react";
import "./StatusFragment.css";

interface myComponentProps {
  className?: string;
  text?: string;
  color?: string;
  bgColor?: string;
  onClick?: (param?: any) => void;
}

const StatusFragment = ({
  className,
  text,
  bgColor,
  color,
  onClick,
}: myComponentProps) => {
  return (
    <span
      className={`smartsend-status-box-wrapper ${className ? className : ""}`}
      style={{ color: color || "", backgroundColor: bgColor || "" }}
      onClick={(e) => {
        e.stopPropagation();
        onClick && onClick(text);
      }}
    >
      <span className={` `}>{text || ""}</span>
    </span>
  );
};

export default StatusFragment;
